import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_INTERNSHIP_STRUCTURES, 
    ADD_NEW_INTERNSHIP_STRUCTURE, 
    UPDATE_INTERNSHIP_STRUCTURE, 
    DELETE_INTERNSHIP_STRUCTURE 
} from "./actionTypes";
import {
    getInternshipStructuresSuccess,
    getInternshipStructuresFail,
    addInternshipStructureSuccess,
    addInternshipStructureFail,
    updateInternshipStructureSuccess,
    updateInternshipStructureFail,
    deleteInternshipStructureSuccess,
    deleteInternshipStructureFail,
   
} from "./actions"

import {
    getInternshipStructures,
    addNewInternshipStructure,
    updateInternshipStructure,
    deleteInternshipStructure,
   
} from "helpers/internship-structures/internship_structures_backend_helper";
import { toast } from "react-toastify";

function* fetchInternshipStructures() {
    try {
        const response = yield call(getInternshipStructures)
        console.log("RESPONSE:", response);
        yield put(getInternshipStructuresSuccess(response))
    } catch (error) {
        yield put(getInternshipStructuresFail(error))
    }
}

function* onAddNewInternshipStructure({ payload }) {
    try {

        
        const response = yield call(addNewInternshipStructure, payload)

        console.log("RESPONSE:", response);
        yield put(addInternshipStructureSuccess(response.internshipStructure))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addInternshipStructureFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateInternshipStructure({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateInternshipStructure, payload)
        console.log("RESPÖNSE: ", response);
        yield put(updateInternshipStructureSuccess(response.internshipStructure))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateInternshipStructureFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteInternshipStructure({ payload}) {

    try {
        const response = yield call(deleteInternshipStructure, payload)
        yield put(deleteInternshipStructureSuccess(response.internshipStructureId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteInternshipStructureFail(error))
        toast.error("Branch  Deleted Failed", { autoClose: 2000 });
    }
}


function* internshipStructureSaga() {
    yield takeEvery(GET_INTERNSHIP_STRUCTURES, fetchInternshipStructures)
    yield takeEvery(ADD_NEW_INTERNSHIP_STRUCTURE, onAddNewInternshipStructure)
    yield takeEvery(UPDATE_INTERNSHIP_STRUCTURE, onUpdateInternshipStructure)
    yield takeEvery(DELETE_INTERNSHIP_STRUCTURE, onDeleteInternshipStructure)
}

export default internshipStructureSaga;